import React, { memo } from 'react';

import TextField from './TextField';

const HouseNumberField = memo((props) => <TextField {...props} />);

HouseNumberField.propTypes = {
  ...TextField.propTypes,
};

HouseNumberField.defaultProps = {
  ...TextField.defaultProps,
  name: 'houseNumber',
  label: 'app:houseNumber',
};

export default HouseNumberField;
